import { gql } from '@apollo/client';

export const GET_DEFAULT_INSTITUTION_LAYOUT = gql`
  query GetDefaultInstitutionLayout {
    layout: getDefaultInstitutionLayout {
      id
      config {
        rows {
          sections {
            sectionTitle
            sectionSize
            columns {
              columnSize
              cards {
                cardTitle
                charts {
                  query
                  type
                  variables
                  formatData
                  width
                  height
                  legend
                  options
                }
              }
            }
          }
        }
      }
    }
  }
`;
